// STUDENT UPDATES TYPES
export const GET_ALL_STUDENT_UPDATES = 'GET_ALL_STUDENT_UPDATES';
export const GET_STUDENT_UPDATE_BY_UPDATES_TYPE = 'GET_STUDENT_UPDATES_BY_UPDATE_TYPE';
export const CREATE_UPDATE = 'CREATE_UPDATE';
export const UPDATE_STUDENT_UPDATE = 'UPDATE_STUDENT_UPDATE';
export const DELETE_STUDENT_UPDATE = 'DELETE_STUDENT_UPDATE';

// LIVE CLASS TYPES
export const GET_ALL_BATCH_TEACHERS = 'GET_ALL_BATCH_TEACHERS';
export const GET_ALL_SCHEDULERS = 'GET_ALL_SCHEDULERS';
export const GET_ALL_BATCH_SUBJECTS = 'GET_ALL_BATCH_SUBJECTS';
export const GET_ALL_BATCH_CHAPTERS = 'GET_ALL_BATCH_CHAPTERS';
export const GET_ALL_LIVE_BATCHES = 'GET_ALL_LIVE_BATCHES';
export const CREATE_LIVE_CLASS = 'CREATE_LIVE_CLASS';
export const CREATE_BATCH_SUBJECT = 'CREATE_BATCH_SUBJECT';
export const CREATE_BATCH_CHAPTER = 'CREATE_BATCH_CHAPTER';
export const SHOW_TO_STUDENTS = 'SHOW_TO_STUDENTS';
export const UPDATE_LIVE_CLASS = 'UPDATE_LIVE_CLASS';
export const DELETE_LIVE_CLASS = 'DELETE_LIVE_CLASS';
export const GET_ALL_ZOOM_ACCOUNTS = 'GET_ALL_ZOOM_ACCOUNTS';
export const START_LIVE_CLASS = 'START_LIVE_CLASS';
export const GET_COMPLETED_LIVE_CLASSES_DATA = 'GET_COMPLETED_LIVE_CLASS_DATA';
export const GET_TODAY_LIVE_CLASSES_DATA = 'GET_TODAY_LIVE_CLASSES_DATA';
export const GET_UPCOMING_LIVE_CLASSES_DATA = 'GET_UPCOMING_LIVE_CLASSES_DATA';
